// src/components/ui/Modal/ModalFooter.tsx
import React from 'react';
import { useResponsive } from '@/hooks/useResponsive';
import styles from './ModalFooter.module.css';

export interface ModalFooterProps {
  children: React.ReactNode;
  className?: string;
  // Добавляем новое свойство для управления расположением элементов на мобильных
  mobileFlex?: 'row' | 'column' | 'auto';
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  children,
  className = '',
  // По умолчанию автоматически определяем расположение
  mobileFlex = 'auto'
}) => {
  // Используем хук адаптивности для определения типа устройства
  const { isMobile, isPortrait } = useResponsive();
  
  // Определяем направление flex-контейнера для мобильных
  let flexContainerClass = styles.buttonContainerRow;
  
  if (mobileFlex === 'auto') {
    // Автоматически определяем направление: для маленьких экранов в портретной ориентации - колонка
    if (isMobile && isPortrait) {
      flexContainerClass = styles.buttonContainerColumn;
    }
  } else if (mobileFlex === 'column' && isMobile) {
    // Принудительно задаем колонку для мобильных
    flexContainerClass = styles.buttonContainerColumn;
  }
  
  return (
    <div className={`
      ${styles.footer} 
      ${isMobile ? styles.footerMobile : ''} 
      ${className}
    `}>
      {/* Добавляем обертку с flex для управления расположением кнопок */}
      <div className={`
        ${styles.buttonContainer} 
        ${flexContainerClass} 
        ${isMobile ? styles.buttonTextMobile : styles.buttonText}
      `}>
        {children}
      </div>
    </div>
  );
};